import { render, staticRenderFns } from "./BatsTroubleshootingComponent.vue?vue&type=template&id=0968978c"
import script from "./BatsTroubleshootingComponent.vue?vue&type=script&lang=js"
export * from "./BatsTroubleshootingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports